module.exports = __webpack_public_path__ + "img/deng.e278239c.png";